import { h, Component } from 'preact';
import { validateIncludes } from '../../plugins/helper';
import { RightIcon } from '../icon';
import { getScriptURL } from '../../plugins/helper';

export class LevelBadge extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imgError: false
        };
    }

    render({ level, textClass }, { imgError }) {
        const cls = textClass || (level.length >= 4 ? "et-text-2xl" : "et-text-4xl");

        if (level === "Starter" || imgError) {
            return <span className={cls}>{level}</span>;
        }

        return (
            <img
                src={getScriptURL() + `/svg/levels/${level.replace(":", "")}.svg`}
                onError={() => this.setState({ imgError: true })}
            />
        );
    }
}

const Level = (props) => {
    const { levels } = props.etest.result;
    const sliceLevels = props.etest.result.certificate_level ? levels.slice(0, levels.indexOf(props.etest.result.certificate_level)) : 'Starter';
    const { certificate_level } = props.etest.result;
    const closeLevelChart = () => {
        document.getElementById('level-sidebar').classList.remove('open');
    }

    const currentIndex = levels.indexOf(certificate_level);
    const nextLevel = levels[currentIndex + 1];

    const showLevelClass = (level) => {
        return `
            ${level === certificate_level || validateIncludes(sliceLevels, level) ? "active" : ""}
            ${level === certificate_level ? "current" : ""}
            ${level === nextLevel ? "next-step" : ""}
        `.trim();
    };

    return (
        <div id="level-sidebar" className="et-sidebar md:et-mt-0 et-mt-5">
            <div className="et-sidebar-bar">
                <div className="et-relative">
                    <button onClick={(e) => closeLevelChart()} className="sidebar-close et-hidden md:et-block" type="button"><svg width="14"
                            height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" data-svg="close-icon">
                            <line fill="none" stroke="#000" stroke-width="1.1" x1="1" y1="1" x2="13" y2="13"></line>
                            <line fill="none" stroke="#000" stroke-width="1.1" x1="13" y1="1" x2="1" y2="13"></line>
                        </svg>
                    </button>
                    <div className="et-flex et-justify-center et-items-center et-pb-4">
                        <div className="et-flex et-flex-col-reverse">
                        {levels && levels.map((level) => {
                            const isNextLevel = level === nextLevel;
                            const textClass = level.length > 3 ? "et-text-xs" : "";

                            return (
                                <div key={level} className={`etest-level ${showLevelClass(level)}`}>
                                    <LevelBadge level={level} textClass={textClass} />

                                    {isNextLevel && (
                                        <div>
                                            <RightIcon size="20" strokeWidth="2" />
                                            <span className="next-step-target">Target</span>
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Level;